const config = {
  baseUri: process.env.NODE_ENV == 'development' ? '/api/api/front' : '/api/front'
}

export default config
